import React, { FormEvent } from "react";
import { api, CompanyEmployeeRoleDto } from "shared/api";
import { formatDate, useApiMethod, UseModalProps } from "shared/lib";
import { Entity, Error, LoadingDots, Modal } from "shared/ui";

export interface IRoleDeleteModal extends UseModalProps {
  companySlug: string;
  data: CompanyEmployeeRoleDto;
}

export const RoleDeleteModal = (props: IRoleDeleteModal) => {
  const submit = useApiMethod(api.companyRbac.companyEmployeeRoleRemove);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await submit.call(props.companySlug, props.data.id);
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={450}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Удаление роли</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Entity>
            <Entity.Field title={props.data.name} />
            <Entity.Field right description={<>Создана {formatDate(props.data.createdAt, { month: "long" })}</>} />
          </Entity>

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Отмена
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Удалить" : <LoadingDots size={4}>Удаление</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

RoleDeleteModal.defaultProps = {};
